import { Editor } from '@tiptap/core';
import React from 'react';

import { Button } from '@/ui/Button';
import { Icon } from '@/ui/Icon';
import { cn } from '@/utils';

interface BulletListMenuItemProps {
	editor: Editor | null;
}

const BulletListMenuItem = (props: BulletListMenuItemProps) => {
	const { editor } = props;

	if (!editor) {
		return null;
	}

	return (
		<Button
			onClick={() => editor.chain().focus().toggleBulletList().run()}
			className={cn('w-6 h-6 text-brand-gray-2 [&>svg]:size-6 [&>svg]:reset p-0 [&>svg]:left-[0px]', {
				'text-brand-blue': editor.isActive('bulletList'),
			})}
			size="icon"
			icon="left"
			variant="tetriary"
		>
			<Icon name="unorderedList" size={24} />
		</Button>
	);
};

export { BulletListMenuItem };
